import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { fontFamilies } from '../../../../../constants/theme';
import { figmaLetterSpacing } from '../../../../../ui/utils';

export const CrossPromotionalSectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '1200px',
  width: '100%',
  padding: '48px 103px 60px',
  boxShadow: `
  -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
   4px  4px 15px   0px rgba(205, 214, 223, 0.25)
`,
  borderRadius: '40px',
  [theme.breakpoints.down('md')]: {
    padding: '48px 40px 30px',
  },
}));

export const SectionPreHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  fontFamily: fontFamilies.quicksand,
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '100%',
  letterSpacing: '0.4px',
  textAlign: 'center',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  whiteSpace: 'pre-line',
  textAlign: 'center',
  fontFamily: fontFamilies.gotham,
  fontWeight: 400,
  fontSize: '60px',
  lineHeight: '77px',
  letterSpacing: '-0.6px',
  textTransform: 'capitalize',

  [theme.breakpoints.down('md')]: {
    fontSize: 36,
    letterSpacing: figmaLetterSpacing(36, -1),
    lineHeight: '42px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 28,
    letterSpacing: figmaLetterSpacing(28, -1),
    lineHeight: '34px',
  },
}));

export const SectionDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '30px',
  letterSpacing: '0.72px',
  textAlign: 'center',
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: {
    fontSize: 18,
    letterSpacing: figmaLetterSpacing(18, -1),
    lineHeight: '24px',
  },
}));

export const SectionImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
  maxWidth: 996,
  maxHeight: 186,
  opacity: 1,
  borderRadius: '30px',
}));

export const SectionContentHeader = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  whiteSpace: 'pre-line',
  fontFamily: fontFamilies.quicksand,
  fontWeight: 600,
  fontSize: '24px',
  lineHeight: '30px',
  letterSpacing: '0.72px',
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    fontSize: 18,
    letterSpacing: figmaLetterSpacing(18, -1),
    lineHeight: '24px',
  },
}));

export const SectionContentListItem = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  fontFamily: fontFamilies.quicksand,
  lineHeight: '22px',
  whiteSpace: 'pre-line',
  fontWeight: 500,
  fontSize: '20px',
  letterSpacing: '0.4px',
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
    letterSpacing: figmaLetterSpacing(18, -1),
    lineHeight: '24px',
  },
}));

export const SectionContentListItemContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
}));

export const SectionContenStyles = {
  maxWidth: '786px',
  margin: '0 auto',
};

export const SectionBottomCaption = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '28px',
  letterSpacing: '0.7px',
  textAlign: 'center',
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
    letterSpacing: figmaLetterSpacing(20, -1),
    lineHeight: '24px',
  },
}));

export const SectionButtonContainer = styled(Box)(({ theme }) => ({
  margin: '0 auto',
}));
